import ReadjustmentRuleParameterHistory from './readjustment-rules-parameter-history.entity';

export default class ReadjustmentRuleHistory {
  rule: string;

  parameters: ReadjustmentRuleParameterHistory[];

  constructor(obj: any = {}) {
    this.rule = obj.rule || '';
    if (obj.parameters) {
      this.parameters = ReadjustmentRuleParameterHistory.ofList(obj.parameters);
    } else {
      this.parameters = [];
    }
  }

  public static of(obj: any = {}): ReadjustmentRuleHistory {
    return new ReadjustmentRuleHistory(obj);
  }

  public static ofList(obj: any[]): ReadjustmentRuleHistory[] {
    return obj.map(this.of)
  }
}
